import { default as React } from "react"
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parse from "html-react-parser"
import { HiExternalLink, HiOutlineDocument } from 'react-icons/hi'
import {
  connectStateResults,
  Highlight,
  Snippet,
  Hits,
  Index,
  Pagination,
  Configure,
  Stats,
  ScrollTo,
} from "react-instantsearch-dom"
import MyLink from "../my-link"
import EventDate from "../event-date"
import { getUnixTimestamp } from "../../utils/events"

const PageHit = ({ hit }) => {
  const excerptSnippet = <Snippet hit={hit} attribute="excerpt" tagName="mark" />
  const title = <Highlight hit={hit} attribute="title" tagName="mark" />
  return <KnowledgeHubArticle props={hit} titleHighlight={title} excerptSnippet={excerptSnippet} />
}

const PaginateResults = connectStateResults(({ searchResults, index }) => {
  const hitCount = searchResults?.nbHits
  return hitCount > 0 ? (
    <>
      <Pagination totalPages={10} />
    </>
  ) : null
})

const HitsInIndexHeading = connectStateResults(({ searchResults, index }) => {
  const hitCount = searchResults?.nbHits
  return hitCount > 0 ? (
    <>
      <div className="mb-4">
        <h2 className="h3">{index.title}</h2>
        <Stats />
      </div>
    </>
  ) : null
})

const HitsInIndex = ({ index }) => {
  return (
    <Index indexName={index.name} indexId={index.id}>
      <ScrollTo>
        {index.id === "upcoming" || index.id === "past" ?
          <HitsInIndexHeading index={index} />
          : null}
        {index.id === "upcoming" ? <Configure filters={`event_timestamp>${nowTimestamp}`} /> :
          index.id === "past" ? <Configure filters={`event_timestamp<${nowTimestamp}`} /> : null}

        <Hits className="Hits" hitComponent={PageHit} />
      </ScrollTo>
      <div className="flex justify-end"><PaginateResults index={index} /></div>
    </Index>
  )
}

const SearchResult = ({ indices }) => {
  return (
    <div>
      {indices.map(index => (
        <HitsInIndex index={index} key={index.name} />
      ))}
    </div>
  )
}

export default SearchResult

const nowTimestamp = getUnixTimestamp(new Date())

export function KnowledgeHubArticle({ props, excerptSnippet, titleHighlight, format = 'list' }) {
  const { featuredImage, date, eventInfo } = props
  const year = props?.Years?.toString() || props?.year
  const title = titleHighlight || props?.title
  const excerpt = excerptSnippet || (props?.excerpt ? parse(props?.excerpt) : null)
  const document = props?.knowledgeHub?.document || props?.internalResource?.document
  const externalLink = (props?.knowledgeHub?.document?.localFile?.publicURL || props?.knowledgeHub?.externalLink) ? props?.slug || props?.uri
    : (props?.internalResource?.document?.localFile?.publicURL && props?.internalResource?.directLink) ? props?.internalResource?.document?.localFile?.publicURL
      : (props?.internalResource?.externalLink?.url && props?.internalResource?.directLink) ? props?.internalResource?.externalLink?.url
        : (props?.postOptions?.externalLink?.url && props?.postOptions?.linkDirectlyToExternalLink) ? props?.postOptions?.externalLink?.url
          : undefined
  const externalLinkTitle = props?.postOptions?.externalLink?.title
  const href = externalLink || props?.slug
  const rawImage = featuredImage?.node?.localFile?.childImageSharp || document?.localFile?.childImageSharp || props?.hero?.image?.localFile?.childImageSharp
  const image = getImage(rawImage)
  const altText = featuredImage?.node?.altText || document?.altText || props?.hero?.image?.altText || props?.title ? `Preview of ${parse(props.title)}` : ""
  const extension = document?.localFile?.extension?.substring(0, 4)
  return <>
    <MyLink className={`search-item hover:no-underline flex ${format === "list" ? "flex-col" : ""} rounded h-full hover-grow`} href={href} target={externalLink ? "_blank" : null} rel="noreferrer">
      {ItemPreview(format, document, image, altText, extension, externalLink)}
      <div className="overflow-x-clip search-item-content">
        {title ? <h3 className="text-base font-sans font-medium my-1 leading-snug text-body">{title}</h3> : null}
        {externalLinkTitle || (eventInfo || (date || year)) ?
          <div className="text-sm mb-0.5 text-gray-800">
            {eventInfo ? <EventDate start={eventInfo.start} end={eventInfo.end} timeZone={eventInfo.timeZone} />
              : date || year ? <span className="">{date || year}</span> : null}
            {externalLinkTitle && (eventInfo || (date || year)) ? <span className="text-gray-600 mx-0.5"> | </span> : null}
            {externalLinkTitle ? <span className="">{externalLinkTitle}</span> : null}
          </div> : null}

        {excerpt ? <div className="text-sm text-gray-600 mb-1">{excerpt}</div> : null}
      </div>
    </MyLink>

  </>
}

function ItemPreview(format = "list", document, image, altText, extension, externalLink) {
  return <div className={`search-item-img-wrapper flex-shrink-0 flex-grow-0 relative`}>
    {image ?
      <GatsbyImage
        image={image}
        alt={altText}
        objectFit={"cover"}
        className={`search-item-img shadow-sm transition`}
        imgClassName={'transition'} />
      : (document?.mediaDetails?.sizes && document?.mediaDetails.sizes[0]?.sourceUrl) ?
        <img src={document?.mediaDetails.sizes[0].sourceUrl} alt={altText}
          className={`search-item-img shadow-sm transition object-cover bg-white`} />
        :
        <div aria-hidden className={`rounded w-full h-full transition flex ${format === "list" ? "items-end justify-start" : "items-center justify-center"} `}><HiOutlineDocument className={`text-7xl leading-none ${format === "list" ? "text-gray-600" : "scale-125 text-gray-200"}`} strokeWidth={1} /></div>}
    {(extension || externalLink) ?
      <span className={`absolute bg-gray-600 text-white text-sm bottom-4 -right-2 px-1.5 py-1 leading-none uppercase rounded`}>
        {extension ? <>{extension}</> : <HiExternalLink className="text-lg" />}
      </span>
      : null}

  </div>
}

